import { Iterator } from "../../src/utils/Iterator";
import SoundController from "../../src/utils/SoundController";
import betModel from "../model/BetModel";
import BetModel from "../model/BetModel";
import UIController from "../../src/ui/UIController";
import stateMachine from "../states/StateMachine";
import AutoplayModel from "../model/AutoplayModel";
import { UIStates } from "../../src/ui/UIStates";
import { UIUpdateEvent } from "../ui/UIUpdateEvents";
import GameModel from "../model/GameModel";
import SoundVars from "../const/SoundVars";
import CommManager from "../controllers/CommManager";
import RequestRegister from "../server/requests/RequestRegister";
import { Tween } from "./../Tween";
import App from "../App";
import SpinModel from "../model/SpinModel";
import ReelGroup from "../views/ReelGroup";
import { DefaultLayers } from "../utils/Layers";
import ViewManager from "../utils/ViewManager";
import BuyFeatureModel from '../model/BuyFeatureModel';
import { Commands } from './CommandEnum';
import CommandManager from './CommandManager';
import { DefaultStates } from "../states/DefaultStates";
import ConsoleUtil from "../utils/ConsoleUtil";
import Cursor from "../views/components/Cursor";
import LocalStorageVars from "../const/LocalStorageVars";
import LocalData from "../utils/LocalData";
import { VendorCommandsEnum } from "../../../src/commands/VendorCommandsEnum";
import MessagePopup from "../ui/popups/MessagePopup";
import Locale from "../utils/Locale";

// Bet Commands

export function IterateCoinsCommand(iterator: Iterator) {
  betModel.cycleCoinSize(iterator);
  UpdateBetCommand();
}

export function IterateBetCommand(iterator: Iterator) {
  betModel.cycleBetMultiplier(iterator);
  UpdateBetCommand();
}

export function IterateLinesCommand(iterator: Iterator) {
  betModel.cycleNumLines(iterator);
}

export function IterateStakeCommand(iterator: Iterator) {
  IterateBetCommand(iterator);
  IterateCoinsCommand(iterator);
}

export function IterateTotalBetCommand(dir?: number) {
  BetModel.cycleTotalBet(dir);
  UpdateBetCommand();
}

export function SetMaxBetCommand() {
  betModel.setStake(betModel.getMaxBet(), betModel.getMaxCoinIndex());
  UpdateBetCommand();
}

export function SetBetCommand(coinSizeIndex: number) {
  ConsoleUtil.log("[GameCommands] Set Bet Command: " + coinSizeIndex);
  betModel.setStake(null, coinSizeIndex);
  SpinModel.update(betModel.getCurrentBetStateData());
  UpdateBetCommand();
}

export function SaveSettingsCommand() {
  if (GameModel.sessionID) {
    CommManager.send(
      RequestRegister.get("saveSettingsRequest"),
      (data) => {
        ConsoleUtil.log("[GameCommands] Saved Settings", data);
      },
      this
    );
  }
}

// Game Commands

export function SkipCommand() {
  stateMachine.skip();
}

export function SpinCommand(playSpinSound: boolean) {
  let skippable = new Array<string>(
    DefaultStates.Idle,
    DefaultStates.Finish,
    DefaultStates.ShowWin);

  if (stateMachine.currentState.name == DefaultStates.ShowWin) {
    const elapsedSeconds = (new Date().getTime() - (<any>stateMachine.currentState).timer) / 1000;
    if (elapsedSeconds < (App.config.autoSpinDelay || 0.1)) {
      // Ensure the player will see the win at least for a small amount of time.
      // Without this check if the player holds the spacebar, s/he will miss the winnings.
      return;
    }
  }

  if (!skippable.includes(stateMachine.currentState.name)) {
    // Fixes the nbt game hangs, when clicking fast
    // on the spin button, during big win
    return;
  }

  if (playSpinSound == true) {
    SoundController.playSound(SoundVars.BUTTON_SPIN, false);
  }

  stateMachine.skip();
}

export function ToggleSpaceToSpinCommand() {
  GameModel.toggleSpaceToSpin();
  UpdateSettingsCommand();
  SoundController.playSound(SoundVars.BUTTON_CLICK);
}

export function ToggleTuboSpinCommand() {
  GameModel.toggleTurboSpin();
  let reelGroup = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup") as ReelGroup;
  reelGroup.toggleTurbo();
  UpdateSettingsCommand();
}

export function ToggleSpaceTuboSpinCommand() {
  GameModel.toggleSpaceTurboSpin();
  let reelGroup = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup") as ReelGroup;
  reelGroup.toggleTurbo();
}

export function ToggleLandscapeRestrict(shouldClear?: boolean) {
  if (ViewManager.hasLayer("Orientation")) {
    if (GameModel.isMobile() && window.innerWidth > window.innerHeight && !shouldClear) {
      const scene = ViewManager.getLayer("Orientation").setScene("open");
      scene.interactive = true;
      CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, true);
    } else {
      ViewManager.getLayer("Orientation").completeClear();
      CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
    }
  }
}

// Autoplay Commands

export function StartAutoplayCommand() {
  AutoplayModel.startAutoSpin();
  SpinCommand(true);
}

export function DecrimentAutoplay() {
  AutoplayModel.decrementAutoSpinNum();
  UpdateAutoplayCommand();
}

export function StopAutoplayCommand() {
  AutoplayModel.setAutoSpin(-1);
  UIController.setState(UIStates.AUTO_STOP);
}

export function ClearAutoplayLimitsCommand() {
  AutoplayModel.clearLimits();
}

export function SetAutoplaySingleWinLimitCommand(limit: number) {
  AutoplayModel.setWinLimit(limit);
}

export function SetAutoplayLossLimitCommand(limit: number) {
  AutoplayModel.setLossLimit(limit);
}

export function SetAutoplayTotalWinLimitCommand(limit: number) {
  AutoplayModel.setTotalWinLimit(limit);
}

export function ToggleAutoplayStopOnFeatureCommand() {
  AutoplayModel.toggleStopOnFeatureWin();
  UpdateAutoplayCommand();
}

export function ToggleAutoplayStopOnWinCommand() {
  AutoplayModel.toggleStopOnAnyWin();
  UpdateAutoplayCommand();
  SoundController.playSound(SoundVars.BUTTON_CLICK);
}

export function ToggleAutoplayStopOnBigWinCommand() {
  AutoplayModel.toggleStopOnBigWin();
  UpdateAutoplayCommand();
}

// Sound Commands

export function resetAudionCTX() {
  if (!SoundController.isSoundCtxEventAdded) {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState == "hidden") {
        SoundController.toggleMusicWhenVisibilityChange();
        App.instance.paused = true;
      } else {
        let msgBox = new MessagePopup();
        msgBox.show(() => {
          App.instance.paused = false;
          SoundController.toggleMusicWhenVisibilityChange();
        })
        msgBox.setTitle("");
        msgBox.setText(Locale.getString("click_to_continue"));
      }
    });
    SoundController.isSoundCtxEventAdded = true;
  }
}
export function ToggleSoundFXCommand(enabled?: boolean) {
  SoundController.toggleEffects(enabled);
  UpdateSettingsCommand();
}

export function ToggleMusicCommand(enabled?: boolean) {
  SoundController.toggleMusic(enabled);
  UpdateSettingsCommand();
}

export function ToggleMasterSoundCommand(enabled?: { data: { value: any } }) {
  SoundController.toggleMasterSound(enabled);
  UpdateSettingsCommand();
}

export function SetMasterVolumeCommand(volume: number) {
  SoundController.masterVolume = volume;
}

// UI update commands

export function UpdateWinCommand(props?: any) {
  UIController.updateFields(UIUpdateEvent.Win, props);
}

export function UpdateBangupWinCommand() {
  UIController.updateFields(UIUpdateEvent.Bangup_win);
}

export function UpdateTempWinCommand() {
  UIController.updateFields(UIUpdateEvent.TempWin);
}

export function UpdateBalanceCommand() {
  UIController.updateFields(UIUpdateEvent.Balance);
}

export function UpdateSettingsCommand() {
  UIController.updateFields(UIUpdateEvent.Settings);
}

export function UpdateAutoplayCommand() {
  UIController.updateFields(UIUpdateEvent.Autoplay);
}

export function UpdateBetCommand() {
  UIController.updateFields(UIUpdateEvent.Bet);
}

export function UpdateFreeSpinsCommand(value: any) {
  UIController.updateFields(UIUpdateEvent.FreeSpins, value);
}
export function ClearWinFieldCommand() {
  UIController.updateFields(UIUpdateEvent.ClearWin);
}

export function ClearFreeSpinsCommand() {
  UIController.updateFields(UIUpdateEvent.FreeSpins);
}

export function UpdateUICommand() {
  UpdateWinCommand();
  UpdateBalanceCommand();
  UpdateSettingsCommand();
  UpdateAutoplayCommand();
  UpdateBetCommand();
}

// Info Bar Commands

export function UpdateInfoBarCommand() {
  UIController.updateFields(UIUpdateEvent.InfoBar);


  // This command needs to re-trigger itself

  Tween.killDelayedCallsTo(UpdateInfoBarCommand);

  Tween.delayedCall(
    App.config.infoBar.changeTime || 3,
    UpdateInfoBarCommand
  );
}

// View Commands

export function CloseSettingsCommand() {
  if (!UIController.isComponentHidden("settings")) {
    UIController.toggleComponent("settings");
  }
}

export function ToggleAutoplaySettingsCommand() {
  UIController.toggleComponent("settings", "autoplay");
}

export function ToggleBetSettingsCommand() {
  UIController.toggleComponent("settings", "bet");
}

export function ToggleSettingsCommand() {
  UIController.toggleComponent("settings", "settings");
}

export function TogglePaytableCommand() {
  UIController.toggleComponent("settings", "paytable");
}

export function ToggleBetPopupCommand() {
  UIController.toggleComponent("betPopup");
}

export function ToggleAutoplayPopupCommand() {
  UIController.toggleComponent("autoplayPopup");
}

export function ShowErrorPopup(callback) {
  UIController.toggleComponent("errorPopup", callback);
}

export function GoHome() {
  if (GameModel.homeUrl) {
    if (GameModel.homeUrl === "close") {
      window.close();
    } else {
      window.open(GameModel.homeUrl, "_self");
      //     window.location.href = GameModel.urlParams.homeurl;
    }
  } else {
    window.history.back();
  }
}

export function OpenRCHistory() {
  if (GameModel.urlParams.rchistoryurl) {
    window.location.href = GameModel.urlParams.rchistoryurl;
  }
}

export function BuyFeatureSpin() {
  CommandManager.execute(Commands.SPIN);
  BuyFeatureModel.hasBuyFeatureIsTriggered = false;
  BuyFeatureModel.isInBuyFeatureFreeSpins = true;
}

export function ShowBuyFeaturePopup(callback) {
  UIController.toggleComponent("buyFeature", callback);
}

export function UpdateCascadeHistory(callback) {
  UIController.updateFields(UIUpdateEvent.UpdateCascade);
}

export function ClearCascadeHistory(callback) {
  UIController.updateFields(UIUpdateEvent.ClearCascade);
}

export function ToggleCursorCommand(state?: boolean) {
  Cursor.isCustom = !Cursor.isCustom;
  LocalData.saveValue(LocalStorageVars.CUSTOM_MOUSE_CURSOR_ENABLED, Cursor.isCustom);
}
